import { Inject, Injectable } from '@angular/core';
import { SGWTConnect } from './SGWTConnect.service';
import { SGWTConnectRequestPredicate } from './SGWTConnectRequestPredicate';
import * as i0 from "@angular/core";
import * as i1 from "./SGWTConnect.service";
/**
 * SGWTConnectInterceptor selectively adds Authorization header to HTTP requests.
 */
var SGWTConnectInterceptor = /** @class */ (function () {
    function SGWTConnectInterceptor(sgwtConnect, sgwtConnectRequestPredicate) {
        this.sgwtConnect = sgwtConnect;
        this.sgwtConnectRequestPredicate = sgwtConnectRequestPredicate;
    }
    SGWTConnectInterceptor.prototype.intercept = function (request, next) {
        // Don't send the Authorization header to endpoints that don't need it:
        if (!isAuthorizationRequired(this.sgwtConnectRequestPredicate, request)) {
            return next.handle(request);
        }
        // Add Authorization header to the request if currently authorized:
        var authorizationHeader = this.sgwtConnect.getAuthorizationHeader();
        if (authorizationHeader !== null) {
            request = request.clone({
                headers: request.headers.set('Authorization', authorizationHeader)
            });
        }
        return next.handle(request);
    };
    SGWTConnectInterceptor.ɵfac = function SGWTConnectInterceptor_Factory(t) { return new (t || SGWTConnectInterceptor)(i0.ɵɵinject(i1.SGWTConnect), i0.ɵɵinject(SGWTConnectRequestPredicate)); };
    SGWTConnectInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SGWTConnectInterceptor, factory: SGWTConnectInterceptor.ɵfac });
    return SGWTConnectInterceptor;
}());
export { SGWTConnectInterceptor };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SGWTConnectInterceptor, [{
        type: Injectable
    }], function () { return [{ type: i1.SGWTConnect }, { type: undefined, decorators: [{
                type: Inject,
                args: [SGWTConnectRequestPredicate]
            }] }]; }, null); })();
/**
 * Determines if authorization headers are required for the given request.
 */
function isAuthorizationRequired(predicate, request) {
    if (typeof predicate === 'function') {
        return predicate(request);
    }
    // This is for users who set strictNullChecks to false
    // in tsconfig making it possible to pass the predicate
    // as null or undefined in SGWTConnectModule.forRoot:
    // tslint:disable-next-line:no-console
    if (console && typeof console.warn === 'function') {
        // tslint:disable-next-line no-console
        console.warn('SGWTConnect: request predicate not specified.' +
            ' All outgoing XHR requests will include your private authorization token.' +
            ' Consider specifying an explicit endpoint predicate, e.g.' +
            ' SGWTConnectModule.forRoot(sgwtConnectFactory, sgwtConnectPredicate)');
    }
    return true;
}
